import * as React from 'react';
import { ControlledTextbox } from '../textbox/controlled-textbox';
import { PrimaryButton } from '../../../components/buttons/primary-button';
import { isValidEmail } from '../../../functions/validation';

export interface IProps {
    formTitle: string;
    nameInputLabel: string;
    namePlaceholder: string;
    emailInputLabel: string;
    emailPlaceholder: string;
    nameRequiredError: string;
    emailRequiredError: string;
    emailInvalidError: string;
    submitCtaText: string;
    setNameAndEmail(name: string, email: string): void;
}

export interface IState {
    name: string,
    email: string,
    nameHasError: boolean,
    nameError: string,
    emailHasError: boolean,
    emailError: string
}

export class RestrictedContentInputs extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            nameHasError: false,
            nameError: "",
            emailHasError: false,
            emailError: "",
        }
    }

    render() {
        return (
            <div className="filterable-list-result-item col-xxl-6 col-xl-6 col-lg-8 col-md-12 col-sm-12">

                <h2>{this.props.formTitle}</h2>

                <ControlledTextbox
                    id={"filterable-list-name-input"}
                    labelText={this.props.nameInputLabel}
                    placeHolder={this.props.namePlaceholder}
                    required={true}
                    value={this.state.name}
                    onInput={this.onNameInput}
                    onKeyDown={this.onKeyDown}
                    hasError={this.state.nameHasError}
                    errorText={this.state.nameError}
                />

                <ControlledTextbox
                    id={"filterable-list-email-input"}
                    labelText={this.props.emailInputLabel}
                    placeHolder={this.props.emailPlaceholder}
                    required={true}
                    value={this.state.email}
                    onInput={this.onEmailInput}
                    onKeyDown={this.onKeyDown}
                    hasError={this.state.emailHasError}
                    errorText={this.state.emailError}
                />

                <PrimaryButton
                    id="filterable-list-btn"
                    isDisabled={false}
                    buttonText={this.props.submitCtaText}
                    onClick={this.onSubmit}
                    customClasses=""
                    testID="" />
            </div>
        )
    }

    onNameInput = (e) => {
        this.setState({
            name: e.target.value
        });
    }

    onEmailInput = (e) => {
        this.setState({
            email: e.target.value
        });
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.onSubmit();
        }
    }

    onSubmit = () => {
        let nameHasError = false;
        let nameError = "";
        let emailHasError = false;
        let emailError = "";

        if (!this.state.name || this.state.name === "") {
            nameHasError = true;
            nameError = this.props.nameRequiredError;
        }

        if (!this.state.email || this.state.email === "") {
            emailHasError = true;
            emailError = this.props.emailRequiredError;
        }
        else if (!isValidEmail(this.state.email)) {
            emailHasError = true;
            emailError = this.props.emailInvalidError;
        }

        this.setState({
            nameHasError: nameHasError,
            emailHasError: emailHasError,
            nameError: nameError,
            emailError: emailError
        });

        if (nameHasError == true || emailHasError == true) {
            return;
        }

        this.props.setNameAndEmail(this.state.name, this.state.email);
    }
}